import React from 'react';
import { LetterData } from './types';

interface LetterTemplate1Props {
  data: LetterData;
  margins?: { top: number; bottom: number; left: number; right: number };
}

// Template 1: Professional Classic - Matches PaginatedTemplate1 resume style
// Font: serif, centered header, gray borders, bullet-separated contact
export const LetterTemplate1: React.FC<LetterTemplate1Props> = ({ data, margins }) => {
  const defaultMargins = { top: 0.5, bottom: 0.5, left: 0.5, right: 0.5 };
  const m = margins || defaultMargins;
  
  return (
    <div 
      className="bg-white text-gray-900 font-document text-[11pt] leading-relaxed"
      style={{
        width: '8.5in',
        minHeight: '11in',
        padding: `${m.top}in ${m.right}in ${m.bottom}in ${m.left}in`,
        boxSizing: 'border-box'
      }}
    >
      {/* Header - Centered with gray border (matches PaginatedTemplate1) */}
      <header className="text-center border-b border-gray-400 pb-2 mb-4">
        <h1 className="text-2xl font-bold text-gray-900 mb-1">
          {data.senderName}
        </h1>
        <div className="text-xs text-gray-600 leading-tight">
          {[data.senderPhone, data.senderCity && data.senderState ? `${data.senderCity}, ${data.senderState}` : data.senderCity, data.senderEmail, data.senderLinkedIn]
            .filter(Boolean)
            .join(' • ')}
        </div>
      </header>

      {/* Date */}
      <div className="mb-4 text-sm">
        {data.date}
      </div>

      {/* Recipient Info */}
      {(data.recipientName || data.recipientCompany) && (
        <div className="mb-4 text-sm">
          {data.recipientName && <div>{data.recipientName}</div>}
          {data.recipientTitle && <div>{data.recipientTitle}</div>}
          {data.recipientCompany && <div>{data.recipientCompany}</div>}
          {data.recipientAddress && <div>{data.recipientAddress}</div>}
        </div>
      )}

      {/* Subject Line */}
      {data.subject && (
        <div className="mb-4 text-sm">
          <span className="font-semibold">Re: </span>{data.subject}
        </div>
      )}

      {/* Salutation */}
      <div className="mb-4 text-sm">
        {data.salutation}
      </div>

      {/* Body Paragraphs */}
      <div className="space-y-4 text-sm text-justify">
        {data.bodyParagraphs.map((paragraph, index) => (
          <p key={index} className="leading-relaxed">
            {paragraph}
          </p>
        ))}
      </div>

      {/* Closing */}
      <div className="mt-6 text-sm text-left">
        <div className="mb-8">{data.closing}</div>
        <div className="text-sm">{data.signature}</div>
      </div>
    </div>
  );
};
